import { log } from './log';

/**
 * No idea what this actually does. 🤷🏻‍♂️
 */
export function afterActiveInstanceBlur()
{
    log('info', 'lifecycle::afterActiveInstanceBlur');
}
